// extracted by mini-css-extract-plugin
export default {"hotelAdminPage":"styles_hotelAdminPage__Fxkw7"};